import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    LoggerType,
} from 'app/enums/label.enums'

const config: SkyNetTableConfig = {
    name: 'Gateway.ConnectedLoggers',
    fields: [
        {
            name: 'loggerNumber',
            labelKey: 'LOGGER',
        },
        {
            name: 'loggerType',
            componentName: 'EnumValue',
            allowedValuesEnum: LoggerType,
            labelKey: 'LOGGER_TYPE',
        },
        {
            name: 'lastMeasuredOnUtc',
            componentName: 'TemperatureAge',
            labelKey: 'LAST_MEASURED_ON_UTC',
        },
    ],
}

export default config
